import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import ClientDashboard from "@/pages/ClientDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import OrderDetail from "@/pages/OrderDetail";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import ListinoPage from "@/pages/ListinoPage";
import PriceListPage from "@/pages/WorkSettingsPage";
import ClientsPage from "@/pages/ClientsPage";
import ArchivePage from "@/pages/ArchivePage";
import MessagesPage from "@/pages/MessagesPage";
import HomePage from "@/pages/public/HomePage";
import ServicesPage from "@/pages/public/ServicesPage";
import AboutPage from "@/pages/public/AboutPage";
import ContactPage from "@/pages/public/ContactPage";
import GestioneSitoPage from "@/pages/GestioneSitoPage";
import OrderOptionsPage from "@/pages/OrderOptionsPage";
import PrivacyPage from "@/pages/public/PrivacyPage";
import { SiteContentProvider } from "@/context/SiteContentContext";
import { Loader2 } from "lucide-react";

function FullLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}

function roleAllowed(userRole, required) {
  if (!required) return true;
  if (required === "staff") return userRole === "admin" || userRole === "operator";
  return userRole === required;
}

function Protected({ children, role }) {
  const { user, checked } = useAuth();
  if (!checked || user === null) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!roleAllowed(user.role, role)) {
    return <Navigate to={user.role === "client" ? "/dashboard" : "/admin"} replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <SiteContentProvider>
          <Routes>
            {/* Public marketing site */}
            <Route path="/" element={<HomePage />} />
            <Route path="/servizi" element={<ServicesPage />} />
            <Route path="/chi-siamo" element={<AboutPage />} />
            <Route path="/contatti" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />

            {/* Portal */}
            <Route path="/dashboard" element={<Protected role="client"><ClientDashboard /></Protected>} />
            <Route path="/admin" element={<Protected role="staff"><AdminDashboard /></Protected>} />
            <Route path="/completati" element={<Protected role="staff"><AdminDashboard view="completed" /></Protected>} />
            <Route path="/archivio" element={<Protected role="staff"><ArchivePage /></Protected>} />
            <Route path="/clienti" element={<Protected role="staff"><ClientsPage /></Protected>} />
            <Route path="/messaggi" element={<Protected role="admin"><MessagesPage /></Protected>} />
            <Route path="/gestione" element={<Protected role="admin"><GestioneSitoPage /></Protected>} />
            <Route path="/opzioni" element={<Protected role="admin"><OrderOptionsPage /></Protected>} />
            <Route path="/listino" element={<Protected><ListinoPage /></Protected>} />
            <Route path="/prezzi" element={<Protected role="admin"><PriceListPage /></Protected>} />
            <Route path="/impostazioni-lavori" element={<Protected role="admin"><PriceListPage /></Protected>} />
            <Route path="/orders/:id" element={<Protected><OrderDetail /></Protected>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </SiteContentProvider>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
